import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { BlockSegmentedNetsProvider } from '@core/modules/admin/provider';

export const initialBlockSegmentedNetsResolver: ResolveFn<
  Promise<boolean>
> = async () => {
  const provider = inject(BlockSegmentedNetsProvider);

  await provider.listBlockNet.execute();

  return true;
};
